// src/components/AboutSection.jsx
import React, { useState } from "react";

// --- Accordion Data ---
const accordionData = [
  {
    title: "Zero-Waste Development",
    content: (
      <>
        <p className="mb-4 text-gray-600">
          We don't bill for hours; we bill for milestones. If the module doesn't solve the specific pain point we identified in the discovery phase, you don't pay for that sprint. We take the technical risk so you can focus on the business growth.
        </p>
        {/* <ul className="space-y-3 text-sm text-gray-700">
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            We don't bill for hours; we bill for milestones. If the module doesn't solve the specific pain point we identified in the discovery phase, you don't pay for that sprint. We take the technical risk so you can focus on the business growth.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Web-Based Tools: Specialized calculators, dashboards, and internal utilities.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            E-Commerce & CMS: Robust platforms designed for seamless user journeys and easy content management.
          </li>
        </ul> */}
      </>
    ),
    isOpenDefault: true,
  },
  {
    title: "Live-Streamed Development",
    content: (
      <>
        <p className="mb-4 text-gray-600">
          We provide a 100% transparent 'Project Command Center.' You get real-time access to our Git pushes, our internal Whatsapp group for your project, and a live dashboard showing exactly what is being worked on right now. No weekly status reports - just 24/7 visibility. 
        </p>
        {/* <ul className="space-y-3 text-sm text-gray-700">
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            We provide a 100% transparent 'Project Command Center.' You get real-time access to our Git pushes, our internal Whatsapp group for your project, and a live dashboard showing exactly what is being worked on right now. No weekly status reports - just 24/7 visibility. 
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Desktop Software: Powerful enterprise tools for Windows, macOS, and Linux.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Utility Apps: Precision-engineered tools to solve specific operational bottlenecks.
          </li>
        </ul> */}
      </>
    ),
    isOpenDefault: false,
  },
  {
    title: "The 90-Day Stability Warranty",
    content: (
      <>
        <p className="mb-4 text-gray-600">
          We don't just 'hand over' the keys. For 90 days post-launch, our lead architect stays assigned to your project for 5 hours a week at zero cost to monitor performance, handle user feedback, and ensure the transition to your internal team is flawless. We scale with you, we don't just ship and run.
        </p>
        {/* <ul className="space-y-3 text-sm text-gray-700">
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Custom AI Agents: Intelligent assistants that handle customer queries or internal data.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
           Workflow Automation: Reducing human error and manual labor through smart AI scripts.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Predictive Analytics: Using your data to forecast trends and make informed business decisions.
          </li>
        </ul> */}
      </>
    ),
    isOpenDefault: false,
  },
//   {
//     title: "Embedded Systems & IoT Solutions",
//     content: (
//       <>
//         <p className="mb-4 text-gray-600">
//           Bridging the physical and digital worlds to save you time, effort, and capital.
//         </p>
//         <ul className="space-y-3 text-sm text-gray-700">
//           <li className="flex items-start">
//             <span className="text-green-600 mr-2 mt-1">✓</span>
//             Custom Hardware Design: Embedded systems built to your specific requirements.
//           </li>
//           <li className="flex items-start">
//             <span className="text-green-600 mr-2 mt-1">✓</span>
//             IoT Integration: Smart sensors and connected devices for real-time monitoring and automation.
//           </li>
//           <li className="flex items-start">
//             <span className="text-green-600 mr-2 mt-1">✓</span>
//             Smart Infrastructure: End-to-end IoT setups that optimize resource usage and reduce costs.
//           </li>
//         </ul>
//       </>
//     ),
//     isOpenDefault: false,
//   },
//   {
//     title: "Enterprise Resource Planning (ERP)",
//     content: (
//       <>
//         <p className="mb-4 text-gray-600">
//           Centralize your operations with a single source of truth.
//         </p>
//         <ul className="space-y-3 text-sm text-gray-700">
//           <li className="flex items-start">
//             <span className="text-green-600 mr-2 mt-1">✓</span>
//             Industry-Specific ERPs: Tailored modules for manufacturing, retail, and logistics.
//           </li>
//           <li className="flex items-start">
//             <span className="text-green-600 mr-2 mt-1">✓</span>
//             Integrated Management: Seamlessly connect HR, Finance, Inventory, and Sales.
//          </li>
//           <li className="flex items-start">
//             <span className="text-green-600 mr-2 mt-1">✓</span>
//             Scalable Architecture: Tools that grow alongside your company.
//           </li>
//         </ul>
//       </>
//     ),
//     isOpenDefault: false,
//   },
];

// --- Accordion Item ---
const AccordionItem = ({ title, content, activeItem, setActiveItem }) => {
  const isOpen = activeItem === title;
  const toggleAccordion = () => setActiveItem(isOpen ? null : title);

  return (
    <div className="border-t border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left text-xl font-medium text-gray-900 hover:text-gray-700 transition duration-200"
        onClick={toggleAccordion}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <span
          className={`text-2xl transform transition-transform duration-300`}
        >
          {isOpen ? "−" : "+"}
        </span>
      </button>

      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? "max-h-96 pb-6" : "max-h-0"
        }`}
      >
        {content}
      </div>
    </div>
  );
};

// --- Main About Section ---
const AboutSection = () => {
  const [activeItem, setActiveItem] = useState(accordionData[0].title);

  return (
    <section className="py-24 bg-gray-50 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* LEFT COLUMN */}
          <div className="lg:pr-10">
            <span className="text-sm font-medium border border-gray-200 rounded-full px-2 py-1 text-gray-600 mb-4 inline-block">
              Our Approach 
            </span>
            <h2 className="text-5xl font-light leading-snug text-gray-900 mb-12">
              Strategic minds. <br /> Real-world impact
            </h2>
            <p className="text-lg text-gray-600 max-w-md mb-8">
              Crack Developers is a service & product-based company delivering
              scalable software solutions. We help businesses innovate,
              optimize, and grow with practical strategies and technology-driven
              approaches.
            </p>
          </div>

          {/* RIGHT COLUMN: Accordion */}
          <div className="pt-20 lg:pt-0">
            <div className="border-b border-gray-200">
              {accordionData.map((item, index) => (
                <AccordionItem
                  key={index}
                  title={item.title}
                  content={item.content}
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
